import React, { useState } from 'react';
import styles from "./myaddress.module.css"
import ProfileMenu from '../../components/profilemenu/ProfileMenu';
import AddAddress from '../../components/shippingAddress/AddAddress';
import Myprofile from '../myprofile/Myprofile';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import DeleteModal from '../../components/deleteAddress/DeleteAddress';
import { deleteShippingAddress } from '../../../redux/userSlice';

const ShippingAddress = () => {
    const dispatch = useDispatch()
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const { user, isLoading } = useSelector(state => state.user)

    const [from, setFrom] = useState('')
    const [editingData, setEditingData] = useState(null)
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [datas, setData] = useState([]);


    const handleClose = () => {
        setIsPopupVisible(false);
    };

    const handleSignupClick = (from, data) => {
        setFrom(from)
        setEditingData(data)
        setIsPopupVisible(true);
    };

    if (isLoading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 20 }}>
                <CircularProgress />
            </div>
        )
    }
    const deletedData = (value) => {
        dispatch(deleteShippingAddress(value));
    };

    //Delete User
    const openDeleteModal = (data) => {
        setData(data);
        setIsDeleteModalOpen(true);
    };
    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };


    return (
        <>
            <Myprofile>

                <div className={styles.prodetailsContainer}>
                    <div className={styles.profileheader}>
                        <h2>Shipping Address</h2>
                        <button className={styles.editButton} onClick={() => handleSignupClick('add', null)}>
                            Add new address
                        </button>
                    </div>
                    <div className={styles.profilebodyContent} style={{ gap: 10, display: 'flex', flexWrap: 'wrap' }}>
                        {user?.shippingAddress?.map((address) => (
                            <div className={styles.card} key={address?._id}>
                                <div className={styles.header}>
                                    <span>Shipping Address</span>
                                </div>
                                <>
                                    <div className={styles.content}>
                                        <p className={styles.name}>{address?.firstName} {" "} {address?.lastName}</p>
                                        <p className={styles.address}>
                                            {address?.streetAddress && `${address?.streetAddress}, `} {address?.unit && `${address?.unit}, `} {address?.city && `${address?.city}, `}
                                            {address?.state && `${address?.state}, `} {address?.country && `${address?.country}, `} {address?.pincode && `${address?.pincode}`}
                                        </p>
                                        <div className={styles.phoneinshipping}>
                                            <p className={styles.phone}>Phone number:</p><p className={styles.phnum}>+91-{address?.phone}</p>
                                        </div>
                                    </div>
                                    <div className={styles.orderbuttons}>
                                        <button className={styles.trackOrderBtn} onClick={() => handleSignupClick('edit', address)}>Edit Address</button>
                                        <button className={styles.trackOrderBtn} onClick={() => openDeleteModal(address?._id)}>Delete Address</button>
                                    </div>
                                </>
                            </div>
                        ))
                        }
                    </div>
                </div>
            </Myprofile>
            {isPopupVisible && (
                <AddAddress onClose={handleClose} from={from} data={editingData} />
            )}
            <DeleteModal
                closeModal={closeDeleteModal}
                open={isDeleteModalOpen}
                data={datas}
                heading={"Delete Address"}
                handleSubject={deletedData}
                description={'Are you sure you want to delete this shipping address?'}
            />
        </>
    );
};

export default ShippingAddress;
